import { common, InputModel, JSONHelper } from '@neo-one/client-common';
import { BinaryReader, utils } from '../utils';
export class Input extends InputModel {
    constructor() {
        super(...arguments);
        this.equals = utils.equals(Input, this, (other) => common.uInt256Equal(this.hash, other.hash) && other.index === this.index);
        this.toKeyString = utils.toKeyString(Input, () => `${this.hashHex}:${this.index}`);
    }
    static deserializeWireBase({ reader }) {
        const hash = reader.readUInt256();
        const index = reader.readUInt16LE();
        return new this({ hash, index });
    }
    static deserializeWire(options) {
        return this.deserializeWireBase({
            context: options.context,
            reader: new BinaryReader(options.buffer),
        });
    }
    serializeJSON(_context) {
        return {
            txid: JSONHelper.writeUInt256(this.hash),
            vout: this.index,
        };
    }
}

//# sourceMappingURL=Input.js.map
